import React from 'react';

import { useTranslation } from 'react-i18next';
import { usePatchChangeDistrictSalesManager } from 'services/Data/CartService';
import CustomInput from '@acnb/CustomComponents/CustomInput/CustomInput';
import SkeletonWrapper from 'Components/SkeletonWrapper';
import GridContainer from '@jumbo/components/GridContainer';
import GridItem from '@jumbo/components/GridItem';
import { Typography } from '@mui/material';

const DistrictSalesManagerSection = ({ cart, isLoading, isDisabled }) => {
  const { t } = useTranslation();

  const { mutate: changeDistrictSalesManager } = usePatchChangeDistrictSalesManager();

  return (
    <SkeletonWrapper
      isLoading={isLoading}
      component={
        <GridContainer>
          <GridItem xs={12}>
            <Typography variant="h1">{t('districtSalesManagerInfo')}</Typography>
          </GridItem>

          <GridItem xs={12}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              {t('districtSalesManagerInfoDescription')}
            </Typography>
          </GridItem>

          <GridItem xs={12}>
            <CustomInput
              labelText={t('companyCode')}
              id="companyCode"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                onBlur: ({ target: { value } }) => {
                  if (cart?.companyCode !== value) {
                    changeDistrictSalesManager({ ...cart, companyCode: value });
                  }
                },
                disabled: !cart || isDisabled,
                defaultValue: cart?.companyCode ?? '',
              }}
            />
          </GridItem>

          <GridItem xs={12}>
            <CustomInput
              labelText={t('glAccount')}
              id="glAccount"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                onBlur: ({ target: { value } }) => {
                  if (cart?.glAccount !== value) {
                    changeDistrictSalesManager({ ...cart, glAccount: value });
                  }
                },
                disabled: !cart || isDisabled,
                defaultValue: cart?.glAccount ?? '',
              }}
            />
          </GridItem>

          <GridItem xs={12}>
            <CustomInput
              labelText={t('costCenter')}
              id="costCenter"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                onBlur: ({ target: { value } }) => {
                  if (cart?.costCenter !== value) {
                    changeDistrictSalesManager({ ...cart, costCenter: value });
                  }
                },
                disabled: !cart || isDisabled,
                defaultValue: cart?.costCenter ?? '',
              }}
            />
          </GridItem>
        </GridContainer>
      }
    />
  );
};

export default DistrictSalesManagerSection;
